/*
 *   File :  viewMessageContent.js
 *   Author URI : https://evoqueinnovativelab.com
 *   Description : Message content
 *   Integrations :
 *   Version : v1.0
 */

/*import packages*/
import React, { useState, useEffect } from 'react';

import styles from '../../styles/components/viewMessageUser.module.scss';
import { SecondaryBtn } from '../cta';
import { DataTable } from '../dataFormating';


export default function ViewMessageUsers(props) {

    const TABLE_COLUMN = [
		{
			name: 'User name',
			selector: row => row.customer_name,
			sortable: false,
			left: true,
			minWidth: '150px',
			// sortFunction: (a, b) => customDateSort(a, b, 'order_time',),
			cell: row => row.customer_name
		},
		{
			name: 'Mobile',
			selector: row => row.mobile,
			sortable: false,
			left: true,
			minWidth: '200px',
			// sortFunction: (a, b) => customDateSort(a, b, 'order_time',),
			cell: row => <span>{row.mobile ? row.mobile : '-'}</span>
		},
		{
			name: 'Email',
			selector: row => row.customer_name,
			sortable: false,
			left: true,
			minWidth: '200px',
			// sortFunction: (a, b) => customDateSort(a, b, 'order_time',),
			cell: row => <span>{row.customer_email ? row.customer_email : '-'}</span>
		},
		// {
		//     name: 'Status',
		//     selector: row => row.customer_name,
		//     sortable: false,
		//     left: true,
		//     minWidth: '200px',
		//     // sortFunction: (a, b) => customDateSort(a, b, 'order_time',),
		//     cell: row => <span>Scheduled</span>
		// },
	]


   

    function _handleCloseModal() {
        props.closeModal();
    }

    function _deleteContent() {

    }

    return (
        <div className={`${styles.e_view_content} modal fade`}
            id={"view-message-users"}
            tabIndex="-1"
            data-bs-backdrop="static"
            aria-labelledby="view-message-users"
            aria-hidden="true">
            <div className={`${styles.e_modal_dialog} modal-dialog modal-dialog-centered`}>
                <div className={`${styles.e_content} modal-content `}>
                    <div className='d-flex justify-content-between pt-2'>
                        <h4>Users({props.data?.customers_list?.length})</h4>
                        <button id="close-pscm"
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="modal"
                            onClick={_handleCloseModal} >
                        </button>
                    </div>
                    {
                        props.data?.message_detail?.type === 3  ?
                        <p className='mb-0'>{`Segment: ${props.data?.message_detail?.segment_type_variable}: 
                            ${ props.data?.message_detail?.segment_type_option_variable ? props.data?.message_detail?.segment_type_option_variable : props.data?.message_detail?.segment_days || '-'}`}</p>
                        :
                        null
                    }
                    
                    <div className={`${styles.e_body} e-segment-user-table-wrap`}>
                        <DataTable
                            pagination={false}
                            columns={TABLE_COLUMN}
                            data={props.data?.customers_list}
                            paginationServer={true}
                            selectableRows={false}
                        />

                    </div>
                </div>
            </div>
        </div>
    )
}